module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/4-0e77918a5562a87900838b3d8c82f021.png";